import { useEffect } from 'react'
import { useAuthStore } from '@/features/auth/model'
import { useClientConfigStore } from '../model/clientConfig.store'

/**
 * Hook to access client configuration
 * Automatically fetches the configuration if needed when the user is authenticated
 */
export function useClientConfig() {
  const { config, isLoaded } = useClientConfigStore()
  const { isLoading } = useAuthStore()
  const fetchClientConfig = useFetchClientConfig()

  useEffect(() => {
    // If config not loaded yet, fetch it
    if (!isLoaded && !isLoading) {
      fetchClientConfig()
    }
  }, [fetchClientConfig, isLoaded, isLoading])

  return { config, isLoaded }
}

/**
 * Fetches the client configuration based on the user's authentication state
 */
export function useFetchClientConfig() {
  const authState = useAuthStore.getState()
  const clientConfig = useClientConfigStore()

  async function fetchClientConfig() {
    // If user is authenticated, fetch client identifier from API
    if (authState.isAuthenticated()) {
      try {
      // NOTE: This would be an actual API call using the auth token
      // NOTE: probably the state template and match up the accountId with the client identifier

        // For now, simulate with a hardcoded value
        const data = { clientIdentifier: 'coles' }

        clientConfig.setClientIdentifier(data.clientIdentifier)
        return data.clientIdentifier
      } catch (error) {
        console.error('Failed to fetch client configuration:', error)
        clientConfig.setClientIdentifier('coles')
        return 'coles'
      }
    } else {
    // Not authenticated, use default
    // TODO: This should be the default client
      useClientConfigStore.getState().setClientIdentifier('coles')
      return 'coles'
    }
  }

  return fetchClientConfig
}
